import clsx from 'clsx'
import React from 'react'
import { DragObjectWithType, useDrop } from 'react-dnd'
import { DragObjectTypes } from '../../dragObjects'
import { HandTile } from '../../models'
import DraggableTile from '../draggable-tile'
import styles from './Hand.module.css'

interface HandProps<T> {
    tiles: HandTile[],
    onTakeBack: (x: T) => any
}

export default function Hand<T extends DragObjectWithType>(props: HandProps<T>) {
    const [{ isOver }, drop] = useDrop<T, {}, { isOver: boolean }>({
        accept: DragObjectTypes.Tile,
        drop: tile => props.onTakeBack(tile),
        collect: monitor => ({
            isOver: !!monitor.isOver(),
        }),
    })


    const tiles = props.tiles.map(t => (
        <div key={t.id} className={styles.tile}>
            <DraggableTile
                key={t.id}
                {...t}
            />
        </div>
    ))

    return (
        <div ref={drop} className={clsx(styles.container, {
            [styles.isTakingBack]: isOver
        })}>
            {tiles}
        </div>
    )
}